import { InjectionToken } from '@angular/core';

export type TutorialStep = {
  imgUrl?: string;
  imgUrl2x?: string;
  youtubeVideoId?: string;
  title: string;
  description: string;
  link?: string;
  isStep0?: boolean;
};

export type TutorialDialogContext =
  | 'video_calling'
  | 'multilang_intro'
  | 'multilang_offer'
  | 'referrals_onboarding';

export const AssetsProvider = new InjectionToken('AssetsProvider');
